import getGraphQlClient from '~graphql/getGraphQlClient';
import {
  CREATE_EDITOR_CANVAS_PAGE,
  UPDATE_EDITOR_CANVAS_PAGE,
} from '~graphql/queries/editorCanvasPages';
import { unmarshalGraphqlResponse } from '~graphql/utils';

export const createEditorCanvasPage = async (fields) => {
  const graphQlClient = await getGraphQlClient();

  const response = await graphQlClient.mutate({
    mutation: CREATE_EDITOR_CANVAS_PAGE,
    variables: { fields },
  });

  const result = unmarshalGraphqlResponse(
    response.data,
    'createEditor_canvas_pages'
  );

  return result.editor_canvas_pages;
};

export const updateEditorCanvasPage = async (id, fields) => {
  const graphQlClient = await getGraphQlClient();

  const response = await graphQlClient.mutate({
    mutation: UPDATE_EDITOR_CANVAS_PAGE,
    variables: { id, fields },
  });

  const result = unmarshalGraphqlResponse(
    response.data,
    'updateEditor_canvas_pages'
  );

  return result.editor_canvas_pages;
};
